import React, { useState } from 'react';
import { Card, FormLayout, TextField, Button, Banner, BlockStack, Text } from '@shopify/polaris';
import { useAuth } from '../contexts/AuthContext';
import zemtrixLogo from '../assets/zemtrix-logo.png';

// Shown instead of the app whenever the signed-in user still has a
// system-generated password - blocks access until they set their own.
const ForcePasswordChange = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { changePassword, logout } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }
    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters long');
      return;
    }

    setLoading(true);
    const result = await changePassword(currentPassword, newPassword);
    setLoading(false);

    if (!result.success) {
      setError(result.error);
    }
  };

  return (
    <div className="zx-login-page">
      <div className="zx-login-card-wrap">
        <Card padding="0">
          <div className="zx-login-accent-bar" />
          <div className="zx-login-card-logo">
            <img src={zemtrixLogo} alt="Zemtrix" />
          </div>
          <div style={{ padding: 'var(--p-space-600)' }}>
            <BlockStack gap="500">
              <BlockStack gap="100">
                <Text as="h2" variant="headingMd">
                  Set a new password
                </Text>
                <Text as="p" tone="subdued">
                  You're signed in with a temporary system-generated password. Set your own before continuing.
                </Text>
              </BlockStack>

              {error && <Banner tone="critical">{error}</Banner>}

              <form onSubmit={handleSubmit}>
                <FormLayout>
                  <TextField
                    label="Current (temporary) password"
                    type="password"
                    value={currentPassword}
                    onChange={setCurrentPassword}
                    autoComplete="current-password"
                    disabled={loading}
                  />
                  <TextField
                    label="New password"
                    type="password"
                    value={newPassword}
                    onChange={setNewPassword}
                    autoComplete="new-password"
                    helpText="At least 8 characters"
                    disabled={loading}
                  />
                  <TextField
                    label="Confirm new password"
                    type="password"
                    value={confirmPassword}
                    onChange={setConfirmPassword}
                    autoComplete="new-password"
                    disabled={loading}
                  />
                  <Button
                    variant="primary"
                    fullWidth
                    submit
                    loading={loading}
                    disabled={!currentPassword || !newPassword || !confirmPassword}
                  >
                    Set password and continue
                  </Button>
                  <Button variant="tertiary" fullWidth onClick={logout} disabled={loading}>
                    Log out instead
                  </Button>
                </FormLayout>
              </form>
            </BlockStack>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
